<template>
  <div class="w-3/4 mx-auto">
    <h1 class="text-xl mt-20 py-3">
      {{ $t('teacher.students') }}
    </h1>
    <div class="flex flex-col w-full items-start mt-8
      divide-y-2 divide-grey-academy-150">
      <round-photo-and-name
        v-for="student in students"
        :key="student.id"
        class="py-3 w-full"
        :person="student"
        textClass="pl-2"
        containerClass="items-center" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import RoundPhotoAndName from './graphics/RoundPhotoAndName.vue';

export default {
  components: { RoundPhotoAndName },
  data() {
    return {
      teacherId: 0,

      students: [],
    };
  },

  created() {
    const route = this.$router.currentRoute.path;
    const teacherId = route.split('/')[2];
    this.teacherId = teacherId !== 'students' ? teacherId : this.user.teacher.id;
    this.getStudents();
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    getStudents() {
      axios.get(`/api/teachers/${this.teacherId}/students`).then(({ data }) => {
        this.students = data;
      }).catch((error) => {
        console.log(error);
      });
    },

  },
};
</script>
